module.exports = __webpack_public_path__ + "img/グループ 255.b319102c.jpg";